export type Venue = {
  slug: '13ka' | 'bio' | 'cifra';
  path: string;
  /** Как должно читаться в выдаче и на карточке, без слова «ресторан» */
  name: string;
  kind: string;
  title: string;
  description: string;
  addressLines: string[];
  place: string;
};

export const VENUES: Venue[] = [
  {
    slug: '13ka',
    path: '/13ka',
    name: 'Теория 13ка',
    kind: 'Кафе',
    title: 'Кафе Теория 13ка — общежитие №13, Долгопрудный',
    description:
      'Кафе Теория в общежитии №13 МФТИ. Долгопрудный, Лихачёвский проезд, д. 2, корп. 1.',
    addressLines: ['г. Долгопрудный,', 'Лихачёвский проезд, д. 2, корп. 1,', 'общежитие №13'],
    place: 'Общежитие №13',
  },
  {
    slug: 'bio',
    path: '/bio',
    name: 'Теория Био',
    kind: 'Кафе',
    title: 'Кафе Теория Био — корпус Физтех.БИО, Долгопрудный',
    description:
      'Кафе Теория Био на 1 этаже корпуса Физтех.БИО. Долгопрудный, Институтский пер., 9, стр. 7.',
    addressLines: ['г. Долгопрудный,', 'Институтский пер., 9, стр. 7,', 'корпус Физтех.БИО, 1 этаж'],
    place: 'Физтех.БИО',
  },
  {
    slug: 'cifra',
    path: '/cifra',
    name: 'Теория Цифра',
    kind: 'Столовая',
    title: 'Столовая Теория Цифра — корпус Физтех.Цифра, Долгопрудный',
    description:
      'Столовая Теория Цифра на −1 этаже корпуса Физтех.Цифра. Долгопрудный, Научный пер., 4, корп. 1.',
    addressLines: ['г. Долгопрудный,', 'Научный пер., 4, корп. 1,', 'корпус Физтех.Цифра, −1 этаж'],
    place: 'Физтех.Цифра',
  },
];

export const RESTAURANT = {
  name: 'Ресторан Теория',
  title: 'Ресторан Теория — кухня и бар, Долгопрудный',
  description:
    'Ресторан Теория, кухня и бар. Долгопрудный, ул. Первомайская, 9/4. Бронь столов и меню ресторана.',
  url: 'https://theoryapp.ru/',
};

export function venueByPath(pathname: string): Venue | undefined {
  const path = pathname.replace(/\/$/, '') || '/';
  return VENUES.find((v) => v.path === path);
}
